import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import * as ReactDOM from 'react-dom';
import { useNavigate, useSearchParams } from 'react-router';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { formatFioForAvatar, userFIOFormatter } from '../../../utils/formatters';
import './authorized.scss';
import { UserPersonalDataView } from './UserPersonalDataView';
import { getClientPersonalData, getProfileData } from '../reducer';
import { UserPassportDataView } from './UserPassportDataView';
import { UserTransportDataView } from './UserTransportDataView';
import { FIELDS_MENU } from '../constants';
import { UserOrganizationsList } from './UserOrganizationsList';
import { UserRepresentativeDataView } from './UserRepresentativeDataView';
import { UserMyRepresentativeDataView } from './UserMyRepresentativeDataView';
import { InformationFormWrapper } from '../../InformationScreenWrapper/components/InformationFormWrapper';
import { showGlobalConfirm } from '../../System/actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { loadRepresentativeById, loadRepresentativeList } from '../actions';
import { RepresentativeAproveInviteFormModal } from './Form/RepresentativeAproveInviteFormModal';
import { errorNotification } from '../../Notifications/notificationDecorator';

export function UserProfilePopUp(props) {
  const {
    close = () => {},
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(FIELDS_MENU.PERSONAL);
  const [aproveForm, setAproveForm] = useState();
  const user = useSelector(getClientPersonalData);
  const [searchParams, setSearchParams] = useSearchParams();
  const invite_Id = searchParams.get('invite_Id');

  const handleClose = () => {
    if (invite_Id) {
      navigate('/');
    } else {
      close();
    }
  };

  const {
    transportList,
  } = useSelector(getProfileData);

  useEffect(() => {
    if (invite_Id) {
      dispatch(loadRepresentativeById(invite_Id)).then(response => {
        setSelected(FIELDS_MENU.MY_REPRESENTATIVES);
        if (response?.data.type === 'attorney') {
          errorNotification('Повторное принятие приглашения', 'Отказ');
          return;
        }
        if (response?.data.user_id === user?.id || !response?.data.user_id) {
          setAproveForm(true);
        } else {
          dispatch(showGlobalConfirm({
            confirmMessage: <div><div className="f2 text-sm-center">Приглашение</div><div className="f4 text-sm-center">Попытка воспользоваться чужим приглашением</div></div>,
            confirmClassName: 'remove-preset',
            hideSubmit: true,
          }));
        }
      }).catch(responseLogWithNotification);
    }
  }, [invite_Id]);

  const {
    formatMessage,
  } = intlShape;

  return ReactDOM.createPortal(
    (
      <div className="user-profile-modal uspd">
        <div className="user-profile-header">
          Просмотр профиля
          <div className="close-button" onClick={handleClose}>
            <Icons customIcon icon="close" className="close" />
          </div>
        </div>
        <div className="user-profile-content-wrapper">
          <div className="user-profile-content">
            <div className="user-profile-content-block">
              <div className="usp-menu">
                <div className="usp-menu-avatar">
                  {formatFioForAvatar(user)}
                </div>
                <div className="usp-menu-user-fio">
                  {userFIOFormatter(user)}
                </div>
                <div className="delimiter" />
                <div className="usp-menu-list">
                  {Object.values(FIELDS_MENU).map((item, index) => (
                    <div
                      key={index}
                      className={classNames('usp-menu-list-item', { isActive: selected === item })}
                      onClick={() => setSelected(item)}
                    >
                      <div className="usp-menu-list-item-title">
                        <Icons customIcon icon={item} />
                        <div>{formatMessage({ id: `user.profile.menu.${item}` })}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="uspd-content">
                {selected === FIELDS_MENU.PASSPORT ? <UserPassportDataView user={user} /> : null}
                {selected === FIELDS_MENU.PERSONAL ? <UserPersonalDataView user={user} /> : null}
                {selected === FIELDS_MENU.TRANSPORT ? <UserTransportDataView userId={user?.id} /> : null}
                {selected === FIELDS_MENU.ORGANIZATION ? <UserOrganizationsList userId={user?.id} /> : null}
                {selected === FIELDS_MENU.MY_REPRESENTATIVES ? <UserMyRepresentativeDataView userId={user?.id} /> : null}
                {selected === FIELDS_MENU.REPRESENTATIVE ? <UserRepresentativeDataView userId={user?.id} /> : null}
                { transportList && aproveForm ? <RepresentativeAproveInviteFormModal onClose={() => setAproveForm(false)} /> : null }
              </div>
            </div>
            <div className="user-profile-footer">
              <div className="uspd-footer-info">Профиль заполнен не полностью. Для его заполнения необходимо перейти в
                ЕСИА
              </div>
              <Button
                variant="secondary"
                onClick={() => window.open('https://esia.gosuslugi.ru/login/', '_blank')}
              >
                Перейти в ЕСИА
              </Button>
            </div>
          </div>
        </div>
        <InformationFormWrapper />
      </div>
    ),
    document.body,
  );
}
